import { useQuery } from '@tanstack/react-query';
import { api } from 'lib/request/api';

// Per-(scenario, area) dropdown option sources for the Type Curve Details form.
// Backend: POST /queries/type_curve_area_details (wrap_parameters :query — the
// flat json body is wrapped server-side). jbuilder camelizes top-level keys, so
// `development_types` arrives as `developmentTypes`.
export interface TypeCurveAreaDetails {
  basins: string[];
  developmentTypes: string[];
  formations: string[];
  statuses: string[];
}

export function useTypeCurveAreaDetails(
  scenarioId?: number | null,
  areaId?: number | null
) {
  return useQuery<TypeCurveAreaDetails, Error>({
    queryKey: ['tc-area-details', scenarioId, areaId],
    queryFn: ({ signal }) =>
      api
        .post('queries/type_curve_area_details', {
          json: {
            type_curve_scenario_id: scenarioId,
            type_curve_area_id: areaId,
          },
          signal,
        })
        .json<TypeCurveAreaDetails>(),
    enabled: typeof scenarioId === 'number' && typeof areaId === 'number',
    staleTime: 300_000,
  });
}
